import * as React from 'react'

function ImageSun(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={686}
      height={685}
      viewBox="0 0 686 685"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M555.997 342.5a214.92 214.92 0 01-2.999 35.835c-5.444 32.12-18.07 61.794-36.184 87.312a214.551 214.551 0 01-50.65 50.659c-25.526 18.113-55.209 30.748-87.346 36.192A213.87 213.87 0 01343 555.497a213.87 213.87 0 01-35.818-2.999c-32.137-5.444-61.82-18.079-87.346-36.192a214.537 214.537 0 01-50.651-50.659c-18.113-25.518-30.739-55.192-36.184-87.312a215.025 215.025 0 01-2.999-35.835c0-12.201 1.023-24.162 2.999-35.801 5.436-32.137 18.071-61.82 36.184-87.346a214.537 214.537 0 0150.651-50.659c25.526-18.113 55.209-30.748 87.346-36.193A213.975 213.975 0 01343 129.502c12.209 0 24.171 1.023 35.818 2.999 32.137 5.445 61.82 18.08 87.346 36.193a214.551 214.551 0 0150.65 50.659c18.114 25.526 30.749 55.209 36.184 87.346a213.667 213.667 0 012.999 35.801z"
        fill="#0078B6"
      />
      <path
        d="M343 489.187c81.013 0 146.687-65.674 146.687-146.687S424.013 195.813 343 195.813 196.313 261.487 196.313 342.5 261.987 489.187 343 489.187z"
        fill="#FDB800"
      />
      <path
        d="M400.595 4.822L376.36 202.815h-66.719L285.406 4.822C304.134 1.644 323.369 0 343.001 0c19.632 0 38.867 1.644 57.594 4.822z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M267.802 220.145l-47.183 47.183L63.507 144.48a344.947 344.947 0 0181.447-81.46l122.848 157.125z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M622.494 144.48L465.382 267.328 418.2 220.145 541.048 63.02a344.94 344.94 0 0181.446 81.46z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M685.5 342.5c0 19.632-1.657 38.894-4.822 57.622l-197.965-24.235v-66.719l197.965-24.235c3.178 18.714 4.822 37.949 4.822 57.567z"
        fill="url(#paint3_linear)"
      />
      <path
        d="M203.287 309.168v66.719L5.322 400.123A345.733 345.733 0 01.5 342.501c0-19.619 1.644-38.854 4.822-57.568l197.965 24.235z"
        fill="url(#paint4_linear)"
      />
      <path
        d="M400.595 680.177c-18.727 3.179-37.962 4.823-57.594 4.823-19.632 0-38.867-1.644-57.595-4.823l24.235-197.992h66.719l24.235 197.992z"
        fill="url(#paint5_linear)"
      />
      <path
        d="M267.802 464.855L144.954 621.98a344.951 344.951 0 01-81.447-81.46L220.62 417.672l47.183 47.183z"
        fill="url(#paint6_linear)"
      />
      <path
        d="M622.494 540.52a344.944 344.944 0 01-81.446 81.46L418.2 464.855l47.182-47.183L622.494 540.52z"
        fill="url(#paint7_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1={343}
          y1={181.474}
          x2={333.628}
          y2={-0.00000191357}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1={230.963}
          y1={230.89}
          x2={112.111}
          y2={97.9791}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1={457.167}
          y1={227.908}
          x2={583.687}
          y2={104.369}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1={493.802}
          y1={353.15}
          x2={685.5}
          y2={342.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1={185.808}
          y1={342.5}
          x2={12.8538}
          y2={342.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1={343}
          y1={505.23}
          x2={343.001}
          y2={685}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint6_linear"
          x1={232.667}
          y1={450.703}
          x2={113.815}
          y2={558.479}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint7_linear"
          x1={463.556}
          y1={455.815}
          x2={587.095}
          y2={577.649}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB800" />
          <stop offset={1} stopColor="#FDB800" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ImageSun
